import { render } from "./CartSuggestProductCard.vue?vue&type=template&id=04a4e572&scoped=true"
import script from "./CartSuggestProductCard.vue?vue&type=script&lang=js"
export * from "./CartSuggestProductCard.vue?vue&type=script&lang=js"

import "./CartSuggestProductCard.vue?vue&type=style&index=0&id=04a4e572&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a4e572"]])

export default __exports__